import { formatPrice } from '@/lib/formatters/currency.formatter'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import type { ProductBuyBox_ProductPriceAndStockFragment } from '@gql-generated/graphql'

export type ProductBuyBoxChargesProps = {
  charges: ProductBuyBox_ProductPriceAndStockFragment['charges'] | undefined
}

export function ProductBuyBoxCharges({
  charges,
}: ProductBuyBoxChargesProps): React.ReactElement | null {
  const { t } = useTranslation(['productBuyBox'])

  const chargesLabels = (charges ?? [])
    .filter((charge) => charge !== null)
    .map((charge) => `${formatPrice(charge.amount)} ${charge.name}`)

  if (chargesLabels.length === 0) {
    return null
  }

  return (
    <span className="mt-1 inline-block uppercase text-brand-2-900">
      {t('productBuyBox:charges.label', { charges: chargesLabels })}
    </span>
  )
}
